import React from 'react'

const Privacy = () => {
  return (
    <div className="w-full bg-white h-full flex flex-col items-center justify-center ">
      <h1 className="text-2xl text-center pt-10 pb-10 font-bold">
        Privacy Statement
      </h1>
      <div className="flex-col lg:max-w-[1250px] ">
        <p className="p-10">
          At AlgoTech Limited, we are committed to ensuring the privacy and
          security of your personal information. This Privacy Policy outlines
          how we collect, use, and protect the data you provide through our
          Google Ads lead form.
        </p>
        <p className="p-10">
          <strong>Information Collection:</strong> We collect the information
          you voluntarily submit through the lead form, including your name,
          email address, phone number, and any additional details you provide.
        </p>
        <p className="p-10">
          <strong>Use of Information:</strong> The information you provide will
          be used to contact you regarding your inquiry and to provide
          information about our services. Your data may also be used for
          internal analytics and improving our services.
        </p>
        <p className="p-10">
          <strong>Data Protection:</strong> We implement appropriate technical
          and organizational measures to safeguard your data. We do not share
          your information with third parties unless required by law.
        </p>
        <p className="p-10">
          <strong>Data Retention:</strong> We retain your data for as long as
          necessary to fulfill the purposes outlined in this policy or as
          required by law. You can request the removal of your data at any time.
        </p>
        <p className="p-10">
          <strong>Your Rights:</strong> You have the right to access, correct,
          or delete your personal data. You can also withdraw your consent for
          data processing.
        </p>
        <p className="p-10">
          <strong>Cookies and Tracking:</strong> Our website may use cookies and
          tracking technologies. You can adjust your browser settings to manage
          cookies.
        </p>
        <p className="p-10">
          <strong>Third-Party Links:</strong> Our lead form may contain links to
          third-party websites. We are not responsible for their privacy
          practices.
        </p>
        <p className="p-10">
          <strong>Updates:</strong> This Privacy Policy is subject to change.
          Updates will be posted on our website.
        </p>
        <p className="p-10">
          <strong>Contact Us:</strong> For any privacy-related concerns or
          inquiries, please contact our Privacy Officer at
          <a href="mailto:systems@algotech.com">privacy@algotech.com</a>.
        </p>
        <p className="p-10">
          By submitting your information through our lead form, you consent to
          the terms outlined in this Privacy Policy.
        </p>
        <p className="p-10">Last updated: 21/07/2021.</p>
      </div>
    </div>
  );
}

export default Privacy;